export const cleanObject = (obj: any): any => {
  const _obj = obj;
  for (const [key, value] of Object.entries(_obj)) {
    if (value === undefined) {
      delete _obj[key];
    }
  }
  return _obj;
};

export const mergeURLSearchParams = (
  params1: URLSearchParams,
  params2: URLSearchParams,
): URLSearchParams => {
  return new URLSearchParams({
    ...Object.fromEntries(params1),
    ...Object.fromEntries(params2),
  });
};
